var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGegevensbeschermingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423.4 423.4",
    width: 423,
    height: 423,
    style: {
      enableBackground: "new 0 0 423.4 423.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#776ABB;}\n\t.st1{fill:#352C61;}\n\t.st2{fill:#AFC437;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.3,
    y: 0.2,
    className: "st0",
    width: 97.7,
    height: 97.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.8,
    y: 108.8,
    className: "st1",
    width: 97.7,
    height: 97.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.3,
    y: 108.8,
    className: "st2",
    width: 97.7,
    height: 97.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.7,
    y: 108.8,
    className: "st0",
    width: 97.7,
    height: 97.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.3,
    y: 217.3,
    className: "st0",
    width: 97.7,
    height: 97.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.7,
    y: 217.3,
    className: "st1",
    width: 97.7,
    height: 97.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 217.3,
    className: "st0",
    width: 97.7,
    height: 97.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.3,
    y: 325.9,
    className: "st1",
    width: 97.7,
    height: 97.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGegevensbeschermingLogo);
export default __webpack_public_path__ + "static/media/GegevensbeschermingLogo.d2a1e46332f2fe3f860f1c8ab690c134.svg";
export { ForwardRef as ReactComponent };